/* fm-sr71-gift.js — gated free SR-71 gift, FlightModels
 *
 * Offer: free Lockheed SR-71 Blackbird (26cm) on merchandise >= USD $200,
 * ONLY for visitors who arrived from the SR-71 Meta ad, and ONLY for that
 * browser session (sessionStorage — closing the tab ends the offer).
 *
 * Stacks on top of the Kraken $100 mystery plane; this script never touches
 * Kraken's own reward line, it only owns its own gift variant.
 *
 * Debug: window.__fmSR71
 */
(function () {
  'use strict';

  var CFG = {
    OFFER: 'sr71',
    KEY: 'bx7k29',            // rotate this + the ad URL to kill a leaked link
    GIFT_VARIANT: 52169672032562,
    THRESHOLD_USD: 200,
    REQUIRE_CLICK_ID: true,   // demand fbclid (or an _fbc cookie) as well as the key
    SS_KEY: 'fm_offer_sr71',
    CART_ATTR: 'fm_offer',
    GIFT_PROP: '_fm_gift',
    DEBUG: false
  };

  // layout/theme.liquid is the single source of truth for the rotating key and
  // the offer numbers, so they only ever have to be changed in one place.
  try {
    var over = window.__fmSR71CFG || {};
    Object.keys(over).forEach(function (k) { CFG[k] = over[k]; });
  } catch (e) {}

  // Keep an unwrapped fetch so our own cart writes never re-trigger our hooks.
  var origFetch = window.fetch.bind(window);

  function log() {
    if (!CFG.DEBUG) return;
    try { console.log.apply(console, ['[fm-sr71]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  /* ---------------------------------------------------------------- session */

  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); return true; } catch (e) { return false; } }
  function ssDel(k) { try { window.sessionStorage.removeItem(k); } catch (e) {} }

  function hasClickId(params) {
    if (params.get('fbclid')) return true;
    try { return /(^|;\s*)_fbc=/.test(document.cookie); } catch (e) { return false; }
  }

  // Grant only on a real ad click: correct offer + correct rotating key + a Meta click id.
  function grantFromUrl() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return false; }
    if (params.get('offer') !== CFG.OFFER) return false;
    if (params.get('k') !== CFG.KEY) { log('bad key'); return false; }
    if (CFG.REQUIRE_CLICK_ID && !hasClickId(params)) { log('no click id'); return false; }
    var ok = ssSet(CFG.SS_KEY, '1');
    log('granted', ok);
    return ok;
  }

  // sessionStorage is the single source of truth. If it is unavailable
  // (private mode, blocked storage) we fail CLOSED — no offer, no gift.
  function entitled() { return ssGet(CFG.SS_KEY) === '1'; }

  /* -------------------------------------------------------------- threshold */

  function currencyRate() {
    try {
      var r = parseFloat(window.Shopify.currency.rate);
      return (isFinite(r) && r > 0) ? r : 1;
    } catch (e) { return 1; }
  }

  function activeCurrency() {
    try { return window.Shopify.currency.active || 'USD'; } catch (e) { return 'USD'; }
  }

  // Converted with Shopify Markets' own rate, then rounded UP to a clean
  // marketing number. The SAME value is used for display and for the
  // comparison, so the bar can never disagree with the cart.
  function thresholdCents() {
    var raw = CFG.THRESHOLD_USD * currencyRate();
    var step = raw >= 1000 ? 10 : 5;
    return Math.round(Math.ceil(raw / step) * step * 100);
  }

  function money(cents) {
    var cur = activeCurrency();
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 0, maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (e) {}
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: cur, minimumFractionDigits: 0, maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (e) {}
    return '$' + Math.round(cents / 100);
  }

  /* ------------------------------------------------------------------- cart */

  function prop(item, name) {
    var p = item && item.properties;
    return p ? p[name] : undefined;
  }

  function isOurGift(item) { return item.variant_id === CFG.GIFT_VARIANT; }
  function isKrakenReward(item) { return prop(item, '__krakenCartProduct') === 'Rewards'; }
  function isAddOn(item) { return prop(item, '__krakenCartProduct') === 'ShippingProtection'; }

  // Real merchandise only: excludes our gift, Kraken's mystery plane and
  // the shipping-protection add-on. Uses post-discount line prices.
  function merchCents(cart) {
    var total = 0;
    (cart.items || []).forEach(function (it) {
      if (isOurGift(it) || isKrakenReward(it) || isAddOn(it)) return;
      total += (typeof it.final_line_price === 'number') ? it.final_line_price : it.line_price;
    });
    return total;
  }

  function realLineCount(cart) {
    return (cart.items || []).filter(function (it) {
      return !isOurGift(it) && !isKrakenReward(it) && !isAddOn(it);
    }).length;
  }

  // layout/theme.liquid fires a /cart.js request from an inline head script the
  // moment the page starts parsing. Consuming it here means the very first
  // reconcile does not wait for this deferred script plus a fresh round trip —
  // which is what made the gift visibly slow to appear on an already-qualifying
  // cart. Used once, then discarded so later passes always read fresh state.
  function getCart() {
    var ready = window.__fmSR71Ready;
    if (!ready) return getCartFresh();
    window.__fmSR71Ready = null;
    // Waiting here is what stops this pass and the head script both adding.
    return Promise.resolve(ready).then(function (r) {
      if (r && r.cart && !r.added) return r.cart;   // nothing was added; snapshot is current
      return getCartFresh();                         // an add happened — read the real state
    }, getCartFresh);
  }

  function getCartFresh() {
    return origFetch('/cart.js', {
      headers: { 'Accept': 'application/json' }, credentials: 'same-origin', cache: 'no-store'
    }).then(function (r) { return r.json(); });
  }

  function postJSON(url, body) {
    return origFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }

  /* -------------------------------------------------------------- reconcile */

  var chain = Promise.resolve();   // serialises every gift mutation
  var timer = null;
  var lastSig = '';
  var addFailures = 0;             // consecutive refused adds; stops a retry loop
  var MAX_ADD_FAILURES = 3;

  function schedule(why) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { timer = null; reconcile(why); }, 140);
  }

  function reconcile(why) {
    chain = chain.then(function () {
      return getCart().then(function (cart) {
        var ent = entitled();

        // The threshold is derived from the PAGE's Markets rate but compared
        // against the CART's presentment total. Those can diverge for a moment
        // when the market changes mid-session (or via the Nova currency
        // switcher), and comparing across currencies would hand out or strip a
        // gift wrongly. When they disagree, change nothing and wait.
        if (cart.currency && cart.currency !== activeCurrency()) {
          log('currency mismatch — cart', cart.currency, 'page', activeCurrency(), '— skipping');
          return cart;
        }

        var thr = thresholdCents();
        var merch = merchCents(cart);
        var giftLines = (cart.items || []).filter(isOurGift);
        var giftQty = giftLines.reduce(function (a, b) { return a + b.quantity; }, 0);
        var attrs = cart.attributes || {};

        // Never leave a cart holding nothing but free gifts.
        var wantGift = ent && merch >= thr && realLineCount(cart) > 0;

        var sig = [ent ? 1 : 0, wantGift ? 1 : 0, giftQty, merch, thr, attrs[CFG.CART_ATTR] || ''].join('|');
        log(why, 'ent=' + ent, 'merch=' + merch, 'thr=' + thr, 'giftQty=' + giftQty, 'want=' + wantGift);

        var work = Promise.resolve();
        var mutated = false;

        if (wantGift && giftQty !== 1 && addFailures < MAX_ADD_FAILURES) {
          // Deterministic: clear every gift line, then add exactly one.
          mutated = true;
          work = work.then(function () {
            if (giftQty === 0) return null;
            var u = {}; u[String(CFG.GIFT_VARIANT)] = 0;
            return postJSON('/cart/update.js', { updates: u });
          }).then(function () {
            var props = {};
            props[CFG.GIFT_PROP] = CFG.OFFER;
            return postJSON('/cart/add.js', {
              items: [{ id: CFG.GIFT_VARIANT, quantity: 1, properties: props }]
            });
          }).then(function (res) {
            // fetch() does not reject on 4xx/5xx, so a refused add (product
            // deleted, unpublished, Shopify error) would otherwise look like a
            // success and be retried on every single cart change forever.
            if (res && (res.status || res.description || res.errors)) {
              addFailures++;
              console.warn('[fm-sr71] gift add refused (' + addFailures + '/' + MAX_ADD_FAILURES + ')', res.description || res.message || res.status);
              if (addFailures >= MAX_ADD_FAILURES) {
                console.warn('[fm-sr71] giving up on adding the gift for this page load');
              }
            } else {
              addFailures = 0;
            }
            return res;
          });
        } else if (!wantGift && giftQty > 0) {
          mutated = true;
          work = work.then(function () {
            var u = {}; u[String(CFG.GIFT_VARIANT)] = 0;
            return postJSON('/cart/update.js', { updates: u });
          });
        }

        // The cart attribute is written LAST and then verified. Kraken writes to
        // the cart concurrently (it owns _kraken_drawer) and a colliding write can
        // silently drop ours, which would leave orders mislabelled for reporting.
        // Only touched when it is actually wrong, or when we just mutated the cart
        // and could therefore have raced, so the steady state costs no extra calls.
        var attrWrong = (attrs[CFG.CART_ATTR] || '') !== (ent ? CFG.OFFER : '');
        if (attrWrong || mutated) {
          work = work.then(function () { return syncAttribute(ent, 0); });
        }

        return work.then(function () {
          if (mutated) {
            lastSig = '';
            resyncDrawer();
            return getCartFresh().then(function (c2) { paint(c2); return c2; });
          }
          if (sig !== lastSig) { lastSig = sig; paint(cart); }
          return cart;
        });
      });
    }).catch(function (e) {
      // Never swallow silently: a broken reconcile is a customer-visible bug.
      try { console.warn('[fm-sr71] reconcile failed', e); } catch (e2) {}
    });
    return chain;
  }

  // Write the offer attribute to match the session, then read back and retry
  // once if a concurrent cart write clobbered it.
  function syncAttribute(ent, attempt) {
    return getCartFresh().then(function (cart) {
      var current = (cart.attributes || {})[CFG.CART_ATTR] || '';
      var desired = ent ? CFG.OFFER : '';
      if (current === desired) return null;
      if (attempt >= 2) { log('attribute sync gave up', current, '->', desired); return null; }
      var body = {}; body[CFG.CART_ATTR] = desired;
      return postJSON('/cart/update.js', { attributes: body }).then(function () {
        return syncAttribute(ent, attempt + 1);
      });
    });
  }

  // Kraken renders its drawer from its own state; nudge it after we edit.
  function resyncDrawer() {
    try {
      if (window.KrakenCart && typeof window.KrakenCart.updateCart === 'function') {
        window.KrakenCart.updateCart();
      }
    } catch (e) { log('resync failed', e); }
  }

  /* ----------------------------------------------------------------- the UI */

  var BAR_ID = 'fm-sr71-bar';

  function ensureBar() {
    var el = document.getElementById(BAR_ID);
    if (el) return el;
    el = document.createElement('div');
    el.id = BAR_ID;
    el.setAttribute('role', 'status');
    el.hidden = true;
    (document.body || document.documentElement).appendChild(el);
    return el;
  }

  var SR71_HANDLE = 'lockheed-sr-71-blackbird';

  function onSr71Pdp() {
    return window.location.pathname.indexOf('/products/' + SR71_HANDLE) !== -1;
  }

  // Callout on the SR-71 product page itself: the strongest possible place to
  // say "the thing you are looking at is the free one".
  function ensurePdpCallout() {
    if (!onSr71Pdp()) return null;
    var el = document.getElementById('fm-sr71-pdp');
    if (el) return el;
    var anchor = document.querySelector('.fm-pdp-price-stack') ||
                 document.querySelector('.fm-buy-form') ||
                 document.querySelector('h1.fm-pdp-title');
    if (!anchor || !anchor.parentNode) return null;

    el = document.createElement('div');
    el.id = 'fm-sr71-pdp';
    el.className = 'fm-sr71-pdp';
    el.innerHTML =
      '<span class="fm-sr71-pdp__chip">Your free gift</span>' +
      '<p class="fm-sr71-pdp__text">This is the model you get <strong>free</strong> when your order reaches ' +
      '<strong data-fm-sr71-threshold>&nbsp;</strong> — added automatically, on top of your Mystery Plane.</p>' +
      '<div class="fm-sr71-meter" data-fm-sr71-meter><span class="fm-sr71-meter__fill" data-fm-sr71-fill></span></div>' +
      '<p class="fm-sr71-meter__label" data-fm-sr71-progress></p>';
    anchor.parentNode.insertBefore(el, anchor.nextSibling);
    return el;
  }

  // Grid cards: nothing is overlaid on the product photo (it would sit on top of
  // the FlightModels watermark). Instead the card's own badge becomes "Free" and
  // its stock note gains the offer, so the card reads normally.
  function decorateGridCards(thr, won) {
    var cards = document.querySelectorAll('a[href*="/products/' + SR71_HANDLE + '"]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];

      var badge = card.querySelector('.fm-best-sellers-badge');
      if (badge) {
        if (badge.getAttribute('data-fm-sr71-orig') === null) {
          badge.setAttribute('data-fm-sr71-orig', badge.textContent);
        }
        badge.textContent = 'Free';
        badge.classList.add('fm-sr71-badge');
      }

      var note = card.querySelector('.fm-stock-note');
      if (note) {
        var slot = note.querySelector('[data-fm-sr71-note]');
        if (!slot) {
          slot = document.createElement('span');
          slot.setAttribute('data-fm-sr71-note', '1');
          slot.className = 'fm-sr71-note';
          note.appendChild(slot);
        }
        slot.textContent = won ? 'Free — in your cart' : 'Free on orders over ' + money(thr);
      }
    }
  }

  // Put the cards back exactly as the theme rendered them.
  function undecorateGridCards() {
    var i;
    var badges = document.querySelectorAll('.fm-best-sellers-badge[data-fm-sr71-orig]');
    for (i = 0; i < badges.length; i++) {
      badges[i].textContent = badges[i].getAttribute('data-fm-sr71-orig');
      badges[i].classList.remove('fm-sr71-badge');
      badges[i].removeAttribute('data-fm-sr71-orig');
    }
    var notes = document.querySelectorAll('[data-fm-sr71-note]');
    for (i = 0; i < notes.length; i++) {
      if (notes[i].parentNode) notes[i].parentNode.removeChild(notes[i]);
    }
  }

  function setText(sel, html) {
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) els[i].innerHTML = html;
  }

  var lastCart = null;

  function paint(cart) {
    if (cart) lastCart = cart;
    var ent = entitled();
    var i;
    try { document.documentElement.classList.toggle('fm-sr71-on', ent); } catch (e) {}
    if (!document.body) return;

    var bar = ensureBar();
    if (!ent) { bar.hidden = true; undecorateGridCards(); return; }

    ensurePdpCallout();

    var thr = thresholdCents();
    var merch = cart ? merchCents(cart) : 0;
    var has = cart ? (cart.items || []).some(isOurGift) : false;
    var won = has || merch >= thr;
    var remaining = Math.max(0, thr - merch);

    var slots = document.querySelectorAll('[data-fm-sr71-threshold]');
    for (i = 0; i < slots.length; i++) slots[i].textContent = money(thr);

    decorateGridCards(thr, won);

    // Meters (landing strip + PDP callout).
    var pct = thr > 0 ? Math.max(0, Math.min(100, Math.round((merch / thr) * 100))) : 0;
    var fills = document.querySelectorAll('[data-fm-sr71-fill]');
    for (i = 0; i < fills.length; i++) fills[i].style.width = (won ? 100 : pct) + '%';
    var meters = document.querySelectorAll('[data-fm-sr71-meter]');
    for (i = 0; i < meters.length; i++) meters[i].classList.toggle('is-complete', won);

    var progress = won
      ? '<strong>Unlocked</strong> — your free SR-71 is in the cart.'
      : (merch > 0
          ? '<strong>' + money(remaining) + '</strong> to go'
          : 'Start your order to unlock it');
    setText('[data-fm-sr71-progress]', progress);

    if (won) {
      bar.className = 'fm-sr71-bar fm-sr71-bar--won';
      bar.innerHTML = '<strong>Unlocked!</strong> Your free SR-71 Blackbird is in your cart.';
    } else if (merch > 0) {
      bar.className = 'fm-sr71-bar';
      bar.innerHTML = 'Only <strong>' + money(remaining) + '</strong> away from your free SR-71 Blackbird.';
    } else {
      bar.className = 'fm-sr71-bar';
      bar.innerHTML = 'Free SR-71 Blackbird on orders over <strong>' + money(thr) + '</strong>.';
    }
    bar.hidden = false;
  }

  /* --------------------------------------------------------------- triggers */

  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function hookFetch() {
    if (window.fetch.__fmSR71) return;
    var wrapped = function (input, init) {
      var url = '';
      try { url = (typeof input === 'string') ? input : (input && input.url) || ''; } catch (e) {}
      var isWrite = CART_WRITE.test(url);
      return origFetch(input, init).then(function (res) {
        if (isWrite) schedule('fetch:' + url);
        return res;
      });
    };
    wrapped.__fmSR71 = true;
    window.fetch = wrapped;
  }

  function hookXHR() {
    var open = XMLHttpRequest.prototype.open;
    if (open.__fmSR71) return;
    var patched = function (method, url) {
      try { this.__fmUrl = url; } catch (e) {}
      return open.apply(this, arguments);
    };
    patched.__fmSR71 = true;
    XMLHttpRequest.prototype.open = patched;

    var send = XMLHttpRequest.prototype.send;
    if (send.__fmSR71) return;
    var patchedSend = function () {
      var self = this;
      this.addEventListener('loadend', function () {
        if (self.__fmUrl && CART_WRITE.test(self.__fmUrl)) schedule('xhr:' + self.__fmUrl);
      });
      return send.apply(this, arguments);
    };
    patchedSend.__fmSR71 = true;
    XMLHttpRequest.prototype.send = patchedSend;
  }

  // The pill nav swaps product cards into the grid client-side, so the SR-71
  // ribbon has to be re-applied when the grid re-renders. DOM only — no network.
  function observeGrid() {
    var grid = document.querySelector('.fm-best-sellers-section') ||
               document.querySelector('.fm-best-sellers-grid') ||
               document.querySelector('#product-grid');
    if (!grid) return;
    var t = null;
    try {
      new MutationObserver(function () {
        if (!entitled()) return;
        if (t) clearTimeout(t);
        t = setTimeout(function () { paint(lastCart); }, 120);
      }).observe(grid, { childList: true, subtree: true });
    } catch (e) { log('grid observer failed', e); }
  }

  // Kraken edits its cart internally for drawer trash/qty clicks without any
  // network call we can see, but it always re-renders its shadow DOM.
  function observeDrawer() {
    var tries = 0;
    (function attach() {
      var host = document.getElementById('kraken-cart-drawer-container');
      var root = host && host.shadowRoot;
      if (!root) {
        if (++tries < 40) setTimeout(attach, 500);
        return;
      }
      try {
        new MutationObserver(function () { schedule('drawer'); })
          .observe(root, { childList: true, subtree: true });
        log('drawer observer attached');
      } catch (e) { log('observer failed', e); }
    })();
  }

  /* ------------------------------------------------------------------- boot */

  function boot() {
    grantFromUrl();
    hookFetch();
    hookXHR();
    observeDrawer();
    observeGrid();
    paint(null);
    reconcile('boot');

    // Returning from checkout via the back/forward cache.
    window.addEventListener('pageshow', function (e) { if (e.persisted) schedule('pageshow'); });
    window.addEventListener('focus', function () { schedule('focus'); });
  }

  // Grant as early as possible so the hero can be revealed without a flash.
  grantFromUrl();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.__fmSR71 = {
    cfg: CFG,
    entitled: entitled,
    threshold: thresholdCents,
    money: money,
    reconcile: reconcile,
    cart: getCart,
    merch: function () { return getCart().then(merchCents); },
    revoke: function () { ssDel(CFG.SS_KEY); return reconcile('revoke'); },
    grant: function () { ssSet(CFG.SS_KEY, '1'); return reconcile('grant'); }
  };
})();
